export default "__VITE_ASSET__9veUbj_C__"